const aaa = [
	{
		path: "guahaoAdd",
		component: () => import("@/views/quanxian/guahaoAdd.vue"),
		meta:{title:'挂号'},
	},
]
export default aaa;